import { useState, useEffect } from "react"
import ShareCreditsReport from "./share_credits/ShareCreditsReport"
import ShareCreditsRequest from "./share_credits/ShareCreditsRequest"

const tabList = [
  { id: 1, tab: "Request", onClick: "share-credits-request" },
  { id: 2, tab: "Report", onClick: "share-credits-report" },
]
export default function ShareCredits({ onClose }) {
  const [activeSection, setActiveSection] = useState("share-credits-request")
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className="openProfileItems-container">
      {windowWidth <= 840 && (
        <div className="close-profile-module-container">
          <div className="profile-logo">
            <a href="/">
              <img src="/images/icon/fgh-logo.webp" alt="" />
            </a>
          </div>
          <button className="close-profile-module-btn" onClick={onClose}>
            <img src="/images/icon/ARROW.webp" alt="" /> Back
          </button>
        </div>
      )}
      <div className="change-password-content">
        <div className="openProfile-Label">Share Credits</div>
        <div className="wallet-section-3">
          <ul className="profile-tablist">
            {tabList.map((data) => (
              <li
                key={data.id}
                onClick={() => setActiveSection(data.onClick)}
                className={activeSection === data.onClick ? "active" : ""}
              >
                {data.tab}
              </li>
            ))}
          </ul>
          {activeSection === "share-credits-request" && <ShareCreditsRequest />}
          {activeSection === "share-credits-report" && <ShareCreditsReport />}
        </div>
      </div>
    </div>
  )
}
